import { makeVar } from "@apollo/client";

const who_am_i_refetch = makeVar(null);

export default who_am_i_refetch;
